<template>
  <div>
    <div class="texto-titulo">
      <div class="row q-gutter-sm">
        <q-btn
          label="Anexos"
          no-caps
          :outline="!rightDrawerOpen"
          color="secondary"
          icon="folder"
          class="btn"
          @click="rightDrawerOpen = true"
        />
      </div>
      <Transition name="slide-fade">
        <q-card v-if="rightDrawerOpen" class="drawer-modal">
          <div class="row q-pa-md text-weight-bold">
            <div class="row col-12 items-center">
              <q-icon
                style="cursor: pointer"
                name="close"
                class="q-mr-md"
                size="22px"
                @click="rightDrawerOpen = false"
              />
              <span class="texto-titulo-modal"> Anexos </span>
            </div>
          </div>
          <q-scroll-area style="width: 100%; height: 89%">
            <div class="column col-12 justify-between no-wrap container-modal">
              <div class="q-px-md">
                <div class="col-12">
                  <div class="row items-center text-bold">
                    <q-btn
                      icon="file_upload"
                      color="primary"
                      class="btn-upload"
                      no-caps
                      label="Selecionar Arquivo"
                      @click="abrirDialogoArquivo()"
                    />
                    <span class="q-ml-xs" v-if="file != null">
                      <span v-if="mobile">
                        <span v-if="file?.name.length < 20">
                          <span class="texto-upload">{{ file?.name }}</span>
                        </span>
                        <span v-else>
                          <span class="texto-upload"
                            >{{ file?.name.substring(0, 20) }}...</span
                          >
                          <q-tooltip>{{ file.name }}</q-tooltip>
                        </span>
                      </span>
                      <span v-else>
                        <span v-if="file?.name.length < 22">
                          <span class="texto-upload">{{ file?.name }}</span>
                        </span>
                        <span v-else>
                          <span class="texto-upload"
                            >{{ file?.name.substring(0, 22) }}...</span
                          >
                          <q-tooltip>{{ file.name }}</q-tooltip>
                        </span>
                      </span>
                    </span>
                    <span v-else class="q-ml-xs texto-upload"
                      >Nenhum Arquivo Selecionado</span
                    >
                  </div>
                </div>
                <div class="col-12 q-mt-lg">
                  <!-- <div class="row col-12 justify-end">
                    <q-input
                      rounded
                      outlined
                      dense
                      debounce="300"
                      type="text"
                      class="col-md-6 col-xs-8 input"
                      placeholder="Pesquisar"
                    >
                      <template v-slot:append>
                        <q-icon name="search" />
                      </template>
                    </q-input>
                  </div> -->
                  <q-table
                    grid
                    dense
                    hide-bottom
                    :rows="
                      tipoAnexo == 'fichaCautela' ? listaAnexoFicha : listaAnexo
                    "
                    :rows-per-page-options="[0]"
                  >
                    <template v-slot:item="props">
                      <div class="col-12 q-mt-sm">
                        <div class="row card text-grid-table q-pa-sm">
                          <div class="row col-12 justify-between items-center">
                            <div class="col">
                              <div class="row col-12 q-mt-sm">
                                <span class="row col-12 q-mr-sm"
                                  ><strong class="q-mr-xs">Nome: </strong>
                                  {{ props.row.nomeArquivo }}</span
                                >
                                <span class="row col-12 q-mr-sm"
                                  ><strong class="q-mr-xs">Upload Por: </strong>
                                  {{ props.row.usuarioNome }}</span
                                >
                                <span class="row col-12 q-mr-sm"
                                  ><strong class="q-mr-xs">Data: </strong>
                                  {{
                                    props.row?.criadoEm
                                      .split(" ")[0]
                                      .split("-")
                                      .reverse()
                                      .join("/")
                                  }}</span
                                >
                                <span
                                  v-if="tipoAnexo == 'transferencia'"
                                  class="row col-12 q-mr-sm"
                                  ><strong class="q-mr-xs">Status: </strong>
                                  {{ props.row.statusTransferencia }}</span
                                >
                              </div>
                            </div>
                            <div class="col-4">
                              <div
                                class="row col-12 justify-around items-center"
                              >
                                <div>
                                  <q-btn
                                    :href="props.row.url || props.row.urlAnexo"
                                    color="secondary"
                                    icon="download"
                                    round
                                    flat
                                  />
                                </div>
                                <q-btn
                                  v-if="tipoAnexo == 'transferencia'"
                                  color="red"
                                  icon="delete"
                                  round
                                  flat
                                  @click="
                                    excluirAnexoTransferencia(
                                      props.row.transferenciaAnexoUuid
                                    )
                                  "
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </q-table>
                </div>
              </div>
            </div>
          </q-scroll-area>
        </q-card>
      </Transition>
      <q-dialog v-model="confirm" persistent>
        <q-card
          style="width: 590px"
          class="q-pa-sm text-brand-5 container-modal-excluir text-weight-bolder q-pa-xl"
        >
          <q-card-section class="row col-12 justify-center">
            <span class="texto-excluir-pai"
              >TEM CERTEZA QUE DESEJA ENVIAR O ARQUIVO "{{ file.name }}"?</span
            >
          </q-card-section>

          <div class="row col-12 justify-center">
            <q-btn
              no-caps
              label="Enviar"
              color="positive"
              v-close-popup
              class="btn-excluir"
              icon="check_circle_outline"
              @click="selecionarTipoAnexo()"
            />
            <q-btn
              icon="cancel"
              no-caps
              label="Cancelar"
              color="negative"
              class="btn-excluir q-ml-md"
              v-close-popup
              @click="file = null"
            />
          </div>
        </q-card>
      </q-dialog>
    </div>
    <div
      v-if="rightDrawerOpen"
      @click="rightDrawerOpen = false"
      class="mascara"
    ></div>
  </div>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { salvarCatalogoUuid } from "../composables/salvarCatalogoUuid";

export default {
  props: ["tipoAnexo", "listaAnexo", "transferenciaUuid", "funcionario"],
  emits: ["atualizar"],
  setup(props, { emit }) {
    const store = useStore();
    const quasar = useQuasar();

    const file = ref(null);
    let rightDrawerOpen = ref(false);
    let confirm = ref(false);
    const listaDocumentoFicha = ref([]);
    const fileInputRef = ref(null);
    const listaAnexoFicha = ref([]);
    const catalogoUuid = salvarCatalogoUuid();
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const receberAnexoFicha = async (page = 1, perPage = 100) => {
      if (
        props.funcionario?.matricula == null ||
        props.funcionario?.matricula == ""
      ) {
        return;
      }
      try {
        const response = await store.dispatch(
          "ferramentaria/listarAnexoFuncionario",
          {
            funcionarioId: props.funcionario?.matricula,
            page,
            perPage,
          }
        );
        listaAnexoFicha.value = response.data.resultado.dados;
      } catch (error) {
        console.log(error);
      }
    };

    const abrirDialogoArquivo = () => {
      const fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.style.display = "none";
      fileInput.addEventListener("change", handleFileChange);
      document.body.appendChild(fileInput);
      fileInput.click();
    };

    const handleFileChange = (event) => {
      file.value = event.target.files[0];
      event.target.removeEventListener("change", handleFileChange);
      event.target.remove();
      confirm.value = true;
    };

    const buscarUrlUploadAnexoTransferencia = async () => {
      try {
        const response = await store.dispatch(
          "ferramentaria/buscarUrlAnexoTransferencia",
          {
            transferenciaUuid: props.transferenciaUuid,
            nomeArquivo: file.value.name,
          }
        );
        let formAttributes = response.data.resultado.dados.formAttributes;
        let formInputs = response.data.resultado.dados.formInputs;
        const formData = new FormData();

        for (let input in formInputs) {
          formData.append(input, formInputs[input]);
        }
        formData.append("file", file.value);
        var request = new XMLHttpRequest();
        request.open(formAttributes.method, formAttributes.action);
        request.send(formData);
        enviarAnexoTransferencia(`${formAttributes.action}/${formInputs.key}`);
      } catch (error) {
        console.log(error);
      }
    };

    const buscarUrlUploadAnexoFicha = async () => {
      try {
        const response = await store.dispatch(
          "ferramentaria/buscarUrlAnexoFicha",
          {
            funcionarioId: props.funcionario?.matricula,
            nomeArquivo: file.value.name,
          }
        );
        let formAttributes = response.data.resultado.dados.formAttributes;
        let formInputs = response.data.resultado.dados.formInputs;
        const formData = new FormData();

        for (let input in formInputs) {
          formData.append(input, formInputs[input]);
        }
        formData.append("file", file.value);
        var request = new XMLHttpRequest();
        request.open(formAttributes.method, formAttributes.action);
        request.send(formData);
        adicionarAnexoFuncionario(`${formAttributes.action}/${formInputs.key}`);
      } catch (error) {
        console.log(error);
      }
    };

    const enviarAnexoTransferencia = async (urlImagem) => {
      try {
        await store.dispatch("ferramentaria/enviarAnexoTransferencia", {
          transferenciaUuid: props.transferenciaUuid,
          urlAnexo: urlImagem,
          observacao: "",
          usuarioId: store.state.autenticacao.usuarioLogado.id,
          usuarioNome: store.state.autenticacao.usuarioLogado.nome,
        });
        quasar.notify({
          message: "Anexo enviado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        file.value = null;
        emit("atualizar");
      } catch (error) {
        console.log(error);
      }
    };

    const adicionarAnexoFuncionario = async (urlImagem) => {
      try {
        await store.dispatch("ferramentaria/adicionarAnexoFuncionario", {
          catalogoUuid: catalogoUuid.catalogoUuid.value,
          nome: file.value.name,
          funcionarioId: props.funcionario.matricula,
          funcionarioNome: props.funcionario.nome,
          urlAnexo: urlImagem,
          descricao: file.value.name,
          usuarioId: store.state.autenticacao.usuarioLogado.id,
          usuarioNome: store.state.autenticacao.usuarioLogado.nome,
        });
        quasar.notify({
          message: "Anexo enviado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        file.value = null;
        receberAnexoFicha();
      } catch (error) {
        console.log(error);
      }
    };

    const excluirAnexoTransferencia = async (transferenciaAnexoUuid) => {
      try {
        await store.dispatch("ferramentaria/excluirAnexoTransferencia", {
          transferenciaAnexoUuid,
        });
        quasar.notify({
          message: "Anexo excluído com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        emit("atualizar");
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao excluir anexo.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const selecionarTipoAnexo = () => {
      if (props.tipoAnexo == "transferencia") {
        buscarUrlUploadAnexoTransferencia();
      }
      if (props.tipoAnexo == "fichaCautela") {
        buscarUrlUploadAnexoFicha();
      }
    };

    const verificarTipoAnexo = () => {
      if (props.tipoAnexo == "fichaCautela") {
        receberAnexoFicha();
      }
    };

    watch(
      () => rightDrawerOpen.value,
      () => {
        if (rightDrawerOpen.value) {
          verificarTipoAnexo();
        }
      }
    );

    return {
      file,
      rightDrawerOpen,
      confirm,
      listaDocumentoFicha,
      receberAnexoFicha,
      mobile,
      abrirDialogoArquivo,
      fileInputRef,
      enviarAnexoTransferencia,
      verificarTipoAnexo,
      buscarUrlUploadAnexoFicha,
      handleFileChange,
      buscarUrlUploadAnexoTransferencia,
      selecionarTipoAnexo,
      adicionarAnexoFuncionario,
      excluirAnexoTransferencia,
      listaAnexoFicha,
      catalogoUuid,
    };
  },
};
</script>

<style scoped>
.animacao {
  transition: all 0.5s;
  cursor: pointer;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: calc(100% - 10px);
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100% !important;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
.container-ferramenta-selecionada {
  border: 1px solid black;
  padding: 10px;
  border-radius: 10px;
}
input[type="file"] {
  display: none;
}
.btn-upload {
  margin: 0px 0px 0px 0px;
}
a {
  text-decoration: none;
  color: white;
}
.texto-excluir-pai {
  text-align: center;
  text-justify: inter-word;
  font-size: 23px;
  font-weight: bold;
  color: black;
}
.texto-excluir-filho {
  text-align: center;
  text-justify: inter-word;
  font-size: 15px;
}
.btn-excluir {
  font-size: 16px;
  padding: 0px 25px;
}
.card {
  border: 1px solid #707070;
  border-radius: 5px;
}
.text-grid-table {
  font-size: 15px;
}
.texto-upload {
  font-size: 14px;
}
.texto-titulo-modal {
  font-size: 16px;
}
@media (max-width: 1400px) {
  .drawer-modal {
    height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1000px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 100%;
    height: 85%;
    overflow: hidden;
    top: 103px;
    width: 340px;
  }
  .btn {
    font-size: 13px;
  }
  .btn-upload {
    font-size: 11px;
  }
  .texto-upload {
    font-size: 9px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .texto-titulo-modal {
    font-size: 14px !important;
  }
  .texto-excluir-pai {
    font-size: 17px;
  }
  .container-modal-excluir {
    width: 100%;
    height: 250px;
    padding: 10px 10px 0px 10px;
    margin: 0px;
    border-radius: 10px;
  }
  .btn-excluir {
    font-size: 14px;
  }
}
</style>
